export default "__VITE_ASSET__mNNALQe5__"